export default __webpack_public_path__ + "static/media/okx.17fbe7d5.svg";